export const titleDescriptionContainerStyles = `flex flex-col items-center gap-2`

export const detailsContainerStyles = `px-[24px] flex flex-col items-center justify-center w-full flex-1`

export const imageStyles = `w-[275px] h-[250px] mb-4`

export const containerStyles = `flex flex-col h-full`

export const headerContainerStyles = `pt-[20px] pl-[32px] flex items-center justify-center`

export const descriptionStyles = `text-sm-regular text-center`

export const titleStyles = `text-xl-semibold text-center`
